import { ListCache } from "../../lib/SyncCache.ts";
import * as FwDatas from "../../FwDatas.ts";
import ApiServer from "../../ApiServer.ts";
import { ICredit } from "../fizapilib.auto.ts";

// Augmentation of the generated bean with the properties computed in onDecode
declare module "../fizapilib.auto.ts" {
  interface ICredit {
    twocheckout?: boolean;
    twocheckouttemp?: boolean;
    /** the credit renews itself, or has no end date at all */
    auto?: boolean;
    ownerName?: string;
    /** ends in less than 3 weeks */
    expiressoon?: boolean;
  }
}

export const CreditListCache = new ListCache<ICredit>(ApiServer.creditlistall.prepare(function(credits: ICredit[]){
  var
    currentFamilyID = parseInt(FwDatas.getLastFamilyId().substring(7)),
    activeCredits = credits
      .filter(credit=>credit.creditType==="FAMILYWALL_PREMIUM")
      .filter(credit=>credit.familyIds.length===0 ||credit.familyIds.indexOf(currentFamilyID)>-1)
      .filter(credit=>credit.startDate==undefined || new Date()>credit.startDate)
      .filter(credit=>credit.endDate==undefined || new Date()<credit.endDate)
      .filter(credit=>credit.creditStatus==="ACTIVE"),

    withoutTemp = activeCredits.filter(credit=>credit.paymentType!=="TWOCHECKOUT_TEMP")

  return withoutTemp.length>0?withoutTemp:activeCredits;
}));

ICredit.prototype.onDecode = function(this: ICredit, json): void {
  FwDatas.cache(this)
  this.twocheckout = this.paymentType==="TWOCHECKOUT";
  this.twocheckouttemp = this.paymentType==="TWOCHECKOUT_TEMP";
  this.auto = this.autoRenewType==="AUTO" || this.endDate===undefined;
  if(this.startDate===undefined){
    this.startDate = this.creationDate;
  }
  this.ownerName = this.author().firstName;
  this.expiressoon = this.endDate!==undefined && this.endDate.getTime()<(new Date().getTime()+21*24*3600000) //21 days = 3 semaines
}
